<template>
    <div>
        <component-loading :value="isLoading"/>
        <div v-if="!isLoading">
            <v-row class="mx-0">
                <v-col>
                    <div class="fontColor--text headline">
                        Etiquetas
                    </div>
                </v-col>
            </v-row>
            <ValidationObserver ref="observer">
              <v-row class="linha">
                <v-col cols="12" sm="6">
                  <v-row class="mt-2 mb-0 mx-0">
                      <v-col cols="12">
                          <ValidationProvider ref="tipo" mode="eager" rules="required" v-slot="{ errors }">
                              <autocomplete-cadu
                                  :errorMessage="errors[0]"
                                  title="Destinatário"
                                  v-model="destinatario.nome"
                                  :items="listaDestinatario.map((el) => el.nome)"
                                  :colorText="$vuetify.theme.themes.light.fontColor1"
                                  @index="index => index !== null && index !== -1 ? destinatario.valor = listaDestinatario[index].valor : null"
                              />
                          </ValidationProvider>
                      </v-col>
                  </v-row>
                  <v-row class="mt-2 mb-0 mx-0">
                      <v-col cols="12">
                          <ValidationProvider ref="formato" mode="eager" rules="required" v-slot="{ errors }">
                              <autocomplete-cadu
                                  :errorMessage="errors[0]"
                                  title="Formato"
                                  v-model="tipoFormato.nome"
                                  :items="listaTipoFormato.map((el) => el.nome)"
                                  :colorText="$vuetify.theme.themes.light.fontColor1"
                                  @index="selectFormato"
                              />
                          </ValidationProvider>
                      </v-col>
                  </v-row>
                  <v-row class="mt-2 mb-0 mx-0">
                    <v-col cols="12">
                      <autocomplete-cadu
                          title="Ordenação"
                          v-model="ordenacao.nome"
                          :items="listaOrdenacao.map((el) => el.nome)"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :disabled="!destinatario.valor"
                          @index="index => ordenacao.valor = (index !== null && index !== -1) ? listaOrdenacao[index].valor : null"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="pa-0">
                  <v-row no-gutters>
                    <component-loading :value="isLoadingEtiqueta"/>
                    <v-col v-if="!isLoadingEtiqueta && img">
                      <v-img :src="img" max-width="200" position="absolute"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </ValidationObserver>
            <v-row class="mx-0">
                <v-col>
                    <div class="fontColor--text title">
                        Filtros
                    </div>
                </v-col>
            </v-row>
            <v-row class="mx-0">
              <v-col cols="12" md="4">
                    <checkList-cadu
                      :lengthSize="30"
                      ref="areasCheck"
                      :listaFiltro="listaTipoAreas"
                      :tasks="tipoAreaSelecionadas"
                      v-show="destinatario.nome == 'Departamentos'"
                      titulo="Departamentos"
                      itemTextFiltro="nome"
                      @filtradas="valores => tipoAreaSelecionadas = valores"
                      noGutters
                      overflow
                    />
                </v-col>
            </v-row>
            <v-row class="mx-0">
                <v-col cols="12" md="4">
                    <checkList-cadu
                      :lengthSize="30"
                      ref="unimedCheck"
                      :listaFiltro="listaUnimeds"
                      :tasks="unimedSelecionadas"
                      titulo="Unimed"
                      itemTextFiltro="textoExibicao"
                      @filtradas="valores => unimedSelecionadas = valores"
                      noGutters
                      overflow
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Tipo de Cooperativa"
                        v-model="tipoCooperativa.nome"
                        :items="listaTipoCooperativa.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoCooperativa.id = (index >= 0 && index !== null) ? listaTipoCooperativa[index].id : null"
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Tipo de atuação"
                        v-model="tipoAtuacao.nome"
                        :items="listaTipoAtuacao.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoAtuacao.id = (index >= 0 && index !== null) ? listaTipoAtuacao[index].id : null"
                    />
                </v-col>
            </v-row>
            <v-row class="mx-0">
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Buscar Hierarquia"
                        v-model="buscarHierarquia.nome"
                        :items="listaHierarquia.map((el) => el.textoExibicao)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => buscarHierarquia.id = (index >= 0 && index !== null) ? listaHierarquia[index].id : null"
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Grau de Cooperativa"
                        v-model="grauCooperativa.nome"
                        :items="listaGrauCooperativa.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => grauCooperativa.id = (index >= 0 && index !== null) ? listaGrauCooperativa[index].id : null"
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Tipo de Federação"
                        v-model="tipoFederacao.nome"
                        :items="listaTipoFederacao.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoFederacao.id = (index >= 0 && index !== null) ? listaTipoFederacao[index].id : null"
                    />
                </v-col>
            </v-row>
            <v-row class="mx-0 pr-0">
                <v-col cols="12" md="4">
                    <autocomplete-cadu
                        title="Porte"
                        v-model="tipoPorte.nome"
                        :items="listaTipoPorte.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoPorte.id = (index >= 0 && index !== null) ? listaTipoPorte[index].id : null"
                    />
                </v-col>
                <v-col cols="12" class="novo-flex" lg="1">
                    <autocomplete-cadu
                        title="UF"
                        v-model="tipoUf.nome"
                        :items="listaTipoUf.map((el) => el.sigla)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoUf.id = (index >= 0 && index !== null) ? listaTipoUf[index].id : null"
                    />
                </v-col>
                <v-col cols="12" class="novo-flex-regiao" lg="3">
                    <autocomplete-cadu
                        title="Região Geográfica"
                        v-model="tipoRegiao.nome"
                        :items="listaTipoRegiao.map((el) => el.nome)"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="desativaCamposUnimedSelecionadas"
                        @index="index => tipoRegiao.id = (index >= 0 && index !== null) ? listaTipoRegiao[index].id : null"
                    />
                </v-col>
                <v-col cols="12" md="4" class="pr-0">
                    <span class="font-secundaria fontColor--text" style="font-size: 1rem;">
                        Situação Atual
                    </span>
                    <v-row no-gutters>
                        <v-col cols="auto" class="pr-3">
                            <checkbox-cadu v-model="situacaoAtual" :disable="desativaCamposUnimedSelecionadas" rounded obligatory single value="TODOS">
                                <div slot="text">
                                    Todos
                                </div>
                            </checkbox-cadu>
                        </v-col>
                        <v-col cols="auto" class="px-3">
                            <checkbox-cadu v-model="situacaoAtual" :disable="desativaCamposUnimedSelecionadas" rounded obligatory single value="ATIVO">
                                <div slot="text">
                                    Ativo
                                </div>
                            </checkbox-cadu>
                        </v-col>
                        <v-col cols="auto" class="pl-3">
                            <checkbox-cadu v-model="situacaoAtual" :disable="desativaCamposUnimedSelecionadas" rounded obligatory single value="INATIVO">
                                <div slot="text">
                                    Inativo
                                </div>
                            </checkbox-cadu>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="end" class="pt-8" no-gutters v-if="!$vuetify.breakpoint.xs">
              <v-col cols="auto" class="px-2">
                  <button-cadu @click="limparCampos" :backColor="$vuetify.theme.themes.light.primary2">
                      LIMPAR
                  </button-cadu>
              </v-col>
              <v-col cols="auto" class="pr-4 mr-2">
                  <button-cadu block @click="gerarEtiquetas" class="px-4">
                      GERAR ETIQUETAS
                  </button-cadu>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                  <button-cadu block @click="gerarEtiquetas">
                      GERAR ETIQUETAS
                  </button-cadu>
              </v-col>
              <v-col cols="12">
                  <button-cadu block @click="limparCampos" :backColor="$vuetify.theme.themes.light.primary2">
                      LIMPAR
                  </button-cadu>
              </v-col>
            </v-row>
        </div>
        <error-modal
            v-model="showError"
            :errObj="errObj"
        />
        <overlay-loading v-model="loadingOverlay"/>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Etiquetas from '@/services/Etiquetas/Etiquetas'
import ListarUnimed from '@/services/Unimed/ListarUnimed'
import TipoUnimed from '@/services/Dominios/TipoUnimed'
import TipoFederacao from '@/services/Dominios/TipoFederacao'
import TipoAtuacao from '@/services/Dominios/TipoAtuacao'
import TipoArea from '@/services/Dominios/TipoArea'
import GrauCooperativa from '@/services/Dominios/GrauCooperativa'
import Porte from '@/services/Dominios/Porte'
import Estado from '@/services/AreaAcao/Estado'
import RegiaoGeografica from '@/services/Dominios/RegiaoGeografica'

const reader = new FileReader()

export default {
  components: {
    ValidationProvider, ValidationObserver
  },
  data () {
    return {
      tipoRelatorio: {
        nome: null,
        tipo: null
      },
      listaTipoRelatorio: [],
      tipoFormato: {
        nome: '',
        valor: ''
      },
      listaUnimeds: [],
      listaTipoFormato: [],
      listaTipoRegiao: [],
      situacaoAtual: ['TODOS'],
      tokenBearer: localStorage.getItem('tokenBearer'),
      showError: false,
      errObj: {},
      isLoading: false,
      tipoUnimed: {
        nome: '',
        id: ''
      },
      tipoCooperativa: {
        nome: null,
        id: null
      },
      tipoArea: {
        nome: null,
        id: null
      },
      listaTipoCooperativa: [],
      listaTipoAreas: [],
      tipoAtuacao: {
        nome: null,
        id: null
      },
      listaTipoAtuacao: [],
      buscarHierarquia: {
        nome: null,
        id: null
      },
      listaHierarquia: [],
      grauCooperativa: {
        nome: null,
        id: null
      },
      listaGrauCooperativa: [],
      tipoFederacao: {
        nome: null,
        id: null
      },
      listaTipoFederacao: [],
      tipoPorte: {
        nome: null,
        id: null
      },
      listaTipoPorte: [],
      tipoUf: {
        nome: null,
        id: null
      },
      listaTipoUf: [],
      tipoRegiao: {
        nome: null,
        id: null
      },
      showData: false,
      loadingOverlay: false,
      destinatario: {
        nome: '',
        valor: ''
      },
      listaDestinatario: [],
      ordenacao: {
        nome: null,
        valor: null
      },
      listaOrdenacao: [],
      etiquetas: '',
      unimedSelecionadas: [],
      tipoAreaSelecionadas: [],
      desativaCamposUnimedSelecionadas: false,
      img: '',
      isLoadingEtiqueta: false
    }
  },
  beforeMount () {
    this.getAllCombo()
  },
  methods: {
    selectFormato (index) {
      if (index !== null && index !== -1) {
        this.tipoFormato.valor = this.listaTipoFormato[index].valor
        this.getImg(this.tipoFormato.valor)
        return
      }
      this.tipoFormato.valor = null
    },
    async promiseGeneric (className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    async getAllCombo () {
      this.isLoading = true
      this.etiquetas = new Etiquetas(this.tokenBearer, this.$appConfig.config.API)
      const comboArr = [
        this.getTipoArea(), this.getUnimeds(), this.getHierarquia(), this.getCooperativa(), this.getAtuacao(), this.getFederacao(),
        this.getGrauCooperativa(), this.getPorte(), this.getRegiao(), this.getEstados(),
        this.getTipos(), this.getFormatos()
      ]
      await Promise.all(comboArr)
      this.isLoading = false
    },
    async getTipoArea () {
      const tipoAreas = new TipoArea(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(tipoAreas, 'getTipoArea')
      this.listaTipoAreas = res.data
    },
    async getUnimeds () {
      const listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(listarUnimed, 'getAll')
      this.listaUnimeds = res.data
    },
    async getHierarquia () {
      const listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(listarUnimed, 'getConfederacaoAndFederacao')
      this.listaHierarquia = res.data
    },
    async getCooperativa () {
      const tipoUnimed = new TipoUnimed(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(tipoUnimed, 'getTipoUnimed')
      this.listaTipoCooperativa = res.data
    },
    async getAtuacao () {
      const tipoAtuacao = new TipoAtuacao(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(tipoAtuacao, 'getTipoAtuacao')
      this.listaTipoAtuacao = res.data
    },
    async getFederacao () {
      const tipoFederacao = new TipoFederacao(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(tipoFederacao, 'getTipoFederacao')
      this.listaTipoFederacao = res.data
    },
    async getGrauCooperativa () {
      const grauCooperativa = new GrauCooperativa(this.tokenBearer, this.$appConfig.config.API)

      const res = await this.promiseGeneric(grauCooperativa, 'getGrauCooperativa')
      this.listaGrauCooperativa = res.data
    },
    async getPorte () {
      const porte = new Porte(this.tokenBearer, this.$appConfig.config.API)

      const res = await this.promiseGeneric(porte, 'getPortes')
      this.listaTipoPorte = res.data
    },
    async getRegiao () {
      const regiaoGeografica = new RegiaoGeografica(this.tokenBearer, this.$appConfig.config.API)

      const res = await this.promiseGeneric(regiaoGeografica, 'getRegioes')
      this.listaTipoRegiao = res.data
    },
    async getEstados () {
      const estado = new Estado(this.tokenBearer, this.$appConfig.config.API)

      const res = await this.promiseGeneric(estado, 'getEstados')
      this.listaTipoUf = res.data
    },
    async getTipos () {
      const res = await this.promiseGeneric(this.etiquetas, 'getTipos')
      this.listaDestinatario = res.data
    },
    async getOrdenacoes (tipoEtiqueta) {
      const res = await this.promiseGeneric(this.etiquetas, 'getOrdenacoes', tipoEtiqueta)
      this.listaOrdenacao = res.data
    },
    async getFormatos () {
      const res = await this.promiseGeneric(this.etiquetas, 'getLayout')
      this.listaTipoFormato = res.data
    },
    async getImg (valor) {
      this.isLoadingEtiqueta = true
      const res = await this.promiseGeneric(this.etiquetas, 'getImg', valor)
      const urlCreator = window.URL || window.webkitURL
      this.img = urlCreator.createObjectURL(res.data)
      this.isLoadingEtiqueta = false
    },
    async limparCampos (limpaFiltroUnimed = true) {
      this.situacaoAtual = ['TODOS']
      this.tipoRelatorio = null
      this.dataRelatorio = null

      this.tipoCooperativa = {
        nome: null,
        id: null
      }
      this.tipoAtuacao = {
        nome: null,
        id: null
      }
      this.buscarHierarquia = {
        nome: null,
        id: null
      }
      this.grauCooperativa = {
        nome: null,
        id: null
      }
      this.tipoFederacao = {
        nome: null,
        id: null
      }
      this.tipoPorte = {
        nome: null,
        id: null
      }
      this.tipoUf = {
        nome: null,
        id: null
      }
      this.tipoRegiao = {
        nome: null,
        id: null
      }

      if (limpaFiltroUnimed) {
        this.destinatario = {
          nome: null,
          valor: null
        }
        this.ordenacao = {
          nome: null,
          valor: null
        }
        this.listaOrdenacao = []
        this.tipoFormato = {
          nome: null,
          valor: null
        }
        this.img = ''
        this.tipoAreaSelecionadas = []

        this.unimedSelecionadas = []
        await this.$nextTick()
        await this.$refs.unimedCheck.clearAll()
        await this.$refs.areasCheck.clearAll()
        await this.$refs.tipo.reset()
        await this.$refs.formato.reset()
      }
    },
    async gerarEtiquetas () {
      if (!(await this.$refs.observer.validate())) return

      const data = {
        'layout': this.tipoFormato.valor,
        'tipoEtiqueta': this.destinatario.valor,
        'ordenacao': this.ordenacao.valor || null
      }

      this.loadingOverlay = true
      const response = await this.promiseGeneric(this.etiquetas, 'exportar', data, this.gerarParametros())

      const content = response.headers['content-disposition']
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', content.substring(content.indexOf('"') + 1, content.lastIndexOf('"')))
      document.body.appendChild(link)
      link.click()

      this.loadingOverlay = false
    },
    gerarParametros () {
      const parametros = new URLSearchParams()

      if (this.grauCooperativa.id) parametros.append('grauCooperativaId', this.grauCooperativa.id)
      if (this.tipoPorte.id) parametros.append('porteId', this.tipoPorte.id)
      if (this.tipoRegiao.id) parametros.append('regiaoGeograficaId', this.tipoRegiao.id)
      if (this.tipoAtuacao.id) parametros.append('tipoAtuacaoId', this.tipoAtuacao.id)
      if (this.tipoCooperativa.id) parametros.append('tipoCooperativaId', this.tipoCooperativa.id)
      if (this.tipoFederacao.id) parametros.append('tipoFederacaoId', this.tipoFederacao.id)
      if (this.tipoUf.id) parametros.append('ufId', this.tipoUf.id)
      if (this.buscarHierarquia.id) parametros.append('unimedHierarquiaId', this.buscarHierarquia.id)
      if (this.situacaoAtual[0] !== 'TODOS') parametros.append('situacao', this.situacaoAtual[0] === 'ATIVO')
      this.unimedSelecionadas.forEach((el) => parametros.append('unimedsId', el.id))
      this.tipoAreaSelecionadas.forEach((el) => parametros.append('tipoAreasId', el.id))

      return parametros
    },
    setError (err) {
      if (err.response) {
        this.loadingOverlay = false
        this.isLoading = false
        this.errObj.status = err.response.status
        if (err.response.data instanceof Blob) {
          console.error(err.response.data)
          reader.readAsText(err.response.data)
        } else {
          this.showError = true
          this.errObj.error = err.response.data.message
        }
        document.documentElement.style.overflow = 'hidden'
      }

      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement.result
        this.errObj.error = JSON.parse(text).message
        this.showError = true
      })

      throw err
    }
  },
  watch: {
    'destinatario.valor' (val) {
      this.ordenacao = { nome: null, valor: null }
      this.listaOrdenacao = []
      if (val) {
        this.getOrdenacoes(val)
      }
    },
    unimedSelecionadas (el) {
      if (el.length > 0) {
        this.limparCampos(false)
        this.desativaCamposUnimedSelecionadas = true
        this.situacaoAtual = ['TODOS']
      } else {
        this.desativaCamposUnimedSelecionadas = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-bottom: 1px solid #DEE2E6

@media (min-width: 960px)
  .novo-flex
    flex: 0 0 11.6666666667%
    max-width: 11.6666666667%
  .novo-flex-regiao
    flex: 0 0 21.60%
    max-width: 21.60%

</style>
